import axios from 'axios';
import { baseAPI } from '../config';

/**
 * Con qué se rellena la vista previa del editor de plantillas.
 *
 * Una sola llamada por editor: devuelve los valores, y la sustitución la hace
 * el navegador a cada tecla. Pedirle al servidor el texto resuelto en cada
 * pulsación sería una llamada por letra para enseñar lo mismo.
 */
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

/**
 * @param {string} [companyId] solo lo manda el admin, que edita plantillas de
 *   clientes; a una empresa o a un gestor el backend les da lo suyo y punto.
 */
export async function getPreviewValues(companyId) {
  const { data } = await axios.get(`${baseAPI}/template-preview/values`, {
    headers: headers(),
    params: companyId ? { company_id: companyId } : undefined,
  });
  return data.data;
}
